import { ShareInterface } from './share.model';

export abstract class SocialShare implements ShareInterface {
  constructor(protected readonly url: string) {}

  protected abstract generateShareUrl(): string;

  share(): void {
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

    const screenWidth = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth;
    const screenHeight = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight;
    const width = screenWidth / 2;
    const height = screenHeight / 2;

    const systemZoom = width / window.screen.availWidth;
    const left = width / 2 / 2 / systemZoom + dualScreenLeft;
    const top = height / 2 / 2 / systemZoom + dualScreenTop;
    window.open(this.generateShareUrl(), 'popup', `width=${width},height=${height},scrollbars=no,resizable=no,top=${top},left=${left}`);
  }
}
